import { FEATURE_DECISION_KEYS } from '@web-platform/shared-universal-constants-config';
import { getFeatureDecision } from '@web-platform/shared-universal-utils-frontend/src/config';

import type { Itinerary } from '@web-platform/shared-universal-types/src/redux/state/entities/flights/itineraries';

export const getItineraryTokenOrIdForFlightSearchResults = (itinerary: Itinerary): string => {
  const useItineraryToken = getFeatureDecision(FEATURE_DECISION_KEYS.USE_ITINERARY_TOKEN);
  if (useItineraryToken && itinerary.token) {
    return itinerary.token;
  }
  return itinerary.id;
};
